import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/home',
      name: 'home',
      component: ()=>import('@/components/home')
    },
    {
      path: '/ssoLogin',
      name: 'ssoLogin',
      component: ()=>import('@/components/ssoLogin')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js